// src/components/ConsentDialog.js
import { useState, useEffect } from "react";

const ConsentDialog = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("pairlingo-consent");
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem("pairlingo-consent", "accepted");
        setIsVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem("pairlingo-consent", "declined");
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg p-4 text-gray-700 border-t">
            <div className="max-w-3xl mx-auto flex items-center justify-between">
                <p className="text-sm">
                    We use cookies to enhance your experience and analyze site usage. By clicking "Accept", you consent to our{" "}
                    <a href="/privacy" className="text-indigo-600 underline">Privacy Policy</a>.
                </p>
                <div className="flex space-x-2">
                    <button
                        onClick={handleAccept}
                        className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-500"
                    >
                        Accept
                    </button>
                    <button
                        onClick={handleDecline}
                        className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-500"
                    >
                        Decline
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConsentDialog;
